/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createCapacity } from '../fn/capacity/create-capacity';
import { CreateCapacity$Params } from '../fn/capacity/create-capacity';
import { deleteCapacity } from '../fn/capacity/delete-capacity';
import { DeleteCapacity$Params } from '../fn/capacity/delete-capacity';
import { getTableDetailsById } from '../fn/capacity/get-table-details-by-id';
import { GetTableDetailsById$Params } from '../fn/capacity/get-table-details-by-id';
import { updateCapacity } from '../fn/capacity/update-capacity';
import { UpdateCapacity$Params } from '../fn/capacity/update-capacity';
import { viewCapacity } from '../fn/capacity/view-capacity';
import { ViewCapacity$Params } from '../fn/capacity/view-capacity';
import { viewDefaultCapacityTemplate } from '../fn/capacity/view-default-capacity-template';
import { ViewDefaultCapacityTemplate$Params } from '../fn/capacity/view-default-capacity-template';

@Injectable({ providedIn: 'root' })
export class CapacityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `viewDefaultCapacityTemplate()` */
  static readonly ViewDefaultCapacityTemplatePath = '/api/wtr/Capacity/viewdefaultcapacitytemplate';

  /**
   * View default capacity template for venue with groups and tables.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewDefaultCapacityTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewDefaultCapacityTemplate$Response(params?: ViewDefaultCapacityTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewDefaultCapacityTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * View default capacity template for venue with groups and tables.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewDefaultCapacityTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewDefaultCapacityTemplate(params?: ViewDefaultCapacityTemplate$Params, context?: HttpContext): Observable<void> {
    return this.viewDefaultCapacityTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTableDetailsById()` */
  static readonly GetTableDetailsByIdPath = '/api/wtr/Capacity/gettabledetailsbyId';

  /**
   * Get table details by table Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTableDetailsById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTableDetailsById$Response(params?: GetTableDetailsById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getTableDetailsById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get table details by table Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTableDetailsById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTableDetailsById(params?: GetTableDetailsById$Params, context?: HttpContext): Observable<void> {
    return this.getTableDetailsById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createCapacity()` */
  static readonly CreateCapacityPath = '/api/gmn/Capacity/createcapacity';

  /**
   * Creates new template for capacity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCapacity()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCapacity$Response(params?: CreateCapacity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createCapacity(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates new template for capacity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCapacity$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCapacity(params?: CreateCapacity$Params, context?: HttpContext): Observable<void> {
    return this.createCapacity$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateCapacity()` */
  static readonly UpdateCapacityPath = '/api/gmn/Capacity/updatecapacity';

  /**
   * Save changes for capacity template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCapacity()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCapacity$Response(params?: UpdateCapacity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateCapacity(this.http, this.rootUrl, params, context);
  }

  /**
   * Save changes for capacity template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCapacity$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCapacity(params?: UpdateCapacity$Params, context?: HttpContext): Observable<void> {
    return this.updateCapacity$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewCapacity()` */
  static readonly ViewCapacityPath = '/api/gmn/Capacity/viewcapacity';

  /**
   * View capacity template with groups and tables.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewCapacity()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewCapacity$Response(params?: ViewCapacity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewCapacity(this.http, this.rootUrl, params, context);
  }

  /**
   * View capacity template with groups and tables.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewCapacity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewCapacity(params?: ViewCapacity$Params, context?: HttpContext): Observable<void> {
    return this.viewCapacity$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteCapacity()` */
  static readonly DeleteCapacityPath = '/api/gmn/Capacity/deletecapacity';

  /**
   * Delete capacity template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCapacity()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteCapacity$Response(params?: DeleteCapacity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteCapacity(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete capacity template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCapacity$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteCapacity(params?: DeleteCapacity$Params, context?: HttpContext): Observable<void> {
    return this.deleteCapacity$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
